import { Component, Input } from '@angular/core';

import { PopoverController } from '@ionic/angular';
import { AlcmeonContextService } from 'src/app/core/alcmeon-context/alcmeon-context.service';
import { AbstractModalWithResult } from '../../abstract-modal-with-result';

/**
 * To be used when upgrading to Ionic v6
 */
@Component({
  selector: 'app-datetime-ionic-popover',
  templateUrl: './datetime-ionic-popover.component.html',
  styleUrls: ['./datetime-ionic-popover.component.scss'],
})
export class DatetimeIonicPopoverComponent extends AbstractModalWithResult<string | string[]> {
  static modalId = 'DatetimeIonicPopoverComponent';

  @Input() initialValue: string;
  @Input() withTime: boolean;

  locale: string;

  constructor(popoverController: PopoverController, alcmeonContext: AlcmeonContextService) {
    super(popoverController);
    this.locale = alcmeonContext.self.lang;
  }

  getModalId() {
    return DatetimeIonicPopoverComponent.modalId;
  }
}
